import WindowsManager from './win_mgr';

export default WindowsManager;
